import { autoMount } from '../../../utils/autoMount';
import { PasswordResetSend } from '../../../components/pages/passwordResetSend';

autoMount({ PasswordResetSend });
